document.addEventListener("DOMContentLoaded", function () {
  const overlay = document.getElementById("galleryOverlay");
  const mainImage = document.getElementById("mainImage");
  const galleryImage = document.getElementById("galleryImage");
  const prevArrow = document.getElementById("prevArrow");
  const nextArrow = document.getElementById("nextArrow");
  const prevArrowMobile = document.getElementById("prevArrowMobile");
  const nextArrowMobile = document.getElementById("nextArrowMobile");
  const content = document.querySelector(".product-ficha__content");
  const backButton = document.getElementById("backButton");
  const backButtonMobile = document.getElementById("backButtonMobile");
  const isMobile = window.innerWidth <= 900;

  const FALLBACK_URL = "/products";

  const gallery = Array.from(document.querySelectorAll(".gallery-thumb")).map(
    (img) => img.src
  );

  let currentIndex = 0;
  let isGalleryOpen = false;

  function updateGalleryImage() {
    if (!galleryImage || !gallery.length) return;
    galleryImage.src = gallery[currentIndex];
  }

  function openOverlay(index) {
    currentIndex = index;
    updateGalleryImage();
    if (content) content.classList.add("hidden");
    if (overlay) overlay.classList.add("active");
    isGalleryOpen = true;
  }

  document.querySelectorAll(".gallery-thumb").forEach((img) => {
    img.addEventListener("click", function () {
      const index = parseInt(this.getAttribute("data-index"), 10);
      openOverlay(index);
    });
  });

  function goNext() {
    if (!gallery.length) return;
    currentIndex = (currentIndex + 1) % gallery.length;
    updateGalleryImage();
  }

  function goPrev() {
    if (!gallery.length) return;
    currentIndex = (currentIndex - 1 + gallery.length) % gallery.length;
    updateGalleryImage();
  }

  if (nextArrow) nextArrow.addEventListener("click", goNext);
  if (prevArrow) prevArrow.addEventListener("click", goPrev);
  if (nextArrowMobile) nextArrowMobile.addEventListener("click", goNext);
  if (prevArrowMobile) prevArrowMobile.addEventListener("click", goPrev);

  function sameOrigin(url) {
    try {
      return new URL(url).origin === location.origin;
    } catch {
      return false;
    }
  }

  function goBackOrFallback() {
    if (isGalleryOpen) {
      if (overlay) overlay.classList.remove("active");
      if (content) content.classList.remove("hidden");
      isGalleryOpen = false;
      return;
    }

    const before = location.href;
    const ref = document.referrer;

    if (!ref || !sameOrigin(ref)) {
      location.assign(FALLBACK_URL);
      return;
    }

    history.back();
    setTimeout(() => {
      if (location.href === before) {
        location.assign(FALLBACK_URL);
      }
    }, 300);
  }

  [backButton, backButtonMobile].forEach((button) => {
    if (!button) return;
    button.addEventListener("click", goBackOrFallback);
  });
});
